import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { Exercise } from "../../../models/Exercise";
import useEvents from "../hooks/useEvents";
import "./style.scss";
import "../../../../style/feature.scss";
import "../../../../style/block.scss";
import "../../../../style/buttons.scss";
import { HiOutlineTicket } from "react-icons/hi";
import TicketLineSummary from "../../Universal/TicketLineSummary";
import PreBasketSummary from "../../Universal/PreBasketSummary";
import usePreBasket from "../../Universal/hooks/usePreBasket";
import ReadMore from "../../../../features/ReadMore";
import useBasketManager from "../../SaleMovie/CinemaHall/hooks/useBasketManager";
import useLocaleByLanguage from "../../../../utils/hooks/useLocaleByLanguage";
import { useTranslation } from "react-i18next";
import useCalculatePreBasketQnt from "../../Universal/hooks/useCalculatePreBasketQnt";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import useCountHtmlTagCharacters from "../../../../utils/hooks/useCountHtmlTagCharacters";


interface IProps {
  item: Exercise;
}

const EventSingle: React.FC<IProps> = ({ item }) => {
  const { t } = useTranslation();
  const locale = useLocaleByLanguage();
  const { getTicketsForEvent, tickets } = useEvents();
  const [open, setOpen] = useState(false);
  const { formatTicketAccess, ticketAccess } = useEvents();
  const { preBasket, addItemToBasket, removeItemFromBasket, clearBasket } = usePreBasket();
  const { getBasket } = useBasketManager();
  const { qntState } = useCalculatePreBasketQnt(preBasket);
  const { countHtmlTagCharacters } = useCountHtmlTagCharacters();
  const showTicketLimits = useSelector((state: State) => state.config.configuration.showTicketsPoolForEventsSale);






  const handleDeleteBasket = () => {
    clearBasket();
    setTimeout(() => {
      getBasket();
    }, 200);
  };

  useEffect(() => {
    formatTicketAccess(item);
    getTicketsForEvent(item.exerciseGroup.objectId);
    //eslint-disable-next-line
  }, [item.objectId]);

  return (
    <React.Fragment>
      <div className="SingleEvent shadow">
        <div className="banner ">
          <div className="date">
            <b className="dayname">
              {format(item.startTime, "cccc", {
                locale: locale,
              })}
            </b>
            <b className="day">{format(item.startTime, "d")}</b>
            <b className="fullDates">{format(item.startTime, "dd.MM.yyyy")}</b>
          </div>

          <div className="details">
            <h2 className="eventName">{item.name}</h2>
            <div className="eventDates flex-start-center">
              <div className="flex-start-center">
                <span>{t("data_wydarzenia")}: </span>
                <b>{format(item.startTime, "dd.MM.yyyy")}</b>
                <span> | {t("godz")}: </span> <b> {format(item.startTime, "HH:mm")} </b>
              </div>
            </div>

            {item.description.length > 160 + countHtmlTagCharacters(item.description) ? (
              <ReadMore text={item.description} minLengthText={160 + countHtmlTagCharacters(item.description)} title={item.name} />
            ) : (
              <article className="eventDescription" dangerouslySetInnerHTML={{ __html: item.description }}></article>
            )}

            {!open && (
              <button onClick={() => setOpen(!open)} className="button button-fill-main medium padding-medium">
                {t("pokaz_bilety")} <HiOutlineTicket className="icon" />
              </button>
            )}
            {open && (
              <button
                onClick={() => setOpen(!open)}
                className="button button-fill-background-main medium padding-medium"
              >
                {t("schowaj_bilety")} <HiOutlineTicket className="icon" />
              </button>
            )}
          </div>
          <div style={{ backgroundImage: `url(${item.eventMessage})` }} className="img">
            <div className="whiteOverlay"></div>
          </div>
        </div>

        {open && (
          // <EventTickets item={item} ticketAccess={ticketAccess} tickets={tickets}/>

          <div className="single-event-tickets">

            {showTicketLimits && <div className="head-title flex-start-center">
              <span>
                {t("pozostalo")}:{" "}
                <b>
                  {item.capacity - item.reserved} {t("biletow")}
                </b>
              </span>
            </div>}

            {item.capacity - item.reserved > 0 ? (
              <React.Fragment>
                {tickets.map((itemTicket, index) => (
                  <div className={"ticket-block"} key={index}>
                    {/* <TicketLine item={itemTicket} exercise={ticketAccess} /> */}
                    <TicketLineSummary
                      item={itemTicket}
                      exercise={ticketAccess}
                      preBasket={preBasket}
                      addItemToBasket={addItemToBasket}
                      removeItemFromBasket={removeItemFromBasket}
                      qntState={qntState}
                    />
                  </div>
                ))}
              </React.Fragment>
            ) : (
              <div className="alert alert-red">{t("wszystkie_bilety_zostaly_sprzedane")}</div>
            )}

            <PreBasketSummary preBasket={preBasket} clearBasket={handleDeleteBasket} />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default EventSingle;
